import { FC } from 'react'

import { useParams } from '@tanstack/react-router'

import { Card, CardContent, Grid, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'

import { BookingOverviewTabLayout } from '../BookingLayout'
import { BookingDetailsTitleSkeleton } from '../details/BookingDetailsSkeleton'

export const BookingCustomsSkeleton: FC = () => {
  const { id } = useParams({
    from: '/bookings/$id/customs',
  })
  return (
    <BookingOverviewTabLayout
      title={<BookingDetailsTitleSkeleton />}
      main={
        <Card>
          <CardContent>
            <Stack gap={16}>
              <Grid col={7}>
                <Skeleton variant="badge" fullWidth />
              </Grid>
              <Grid col={6} gap={24}>
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
              </Grid>
              <Grid col={6} gap={24}>
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="button" fullWidth />
              </Grid>
            </Stack>
          </CardContent>
        </Card>
      }
      bookingId={id}
    />
  )
}
